import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "chat-list-container w-full md:w-[360px] flex-shrink-0 border-r border-[#232e3c] flex flex-col" }
const _hoisted_2 = { class: "header bg-[#17212b] p-3 flex items-center justify-between border-b border-[#232e3c]" }
const _hoisted_3 = { class: "flex-1 flex items-center relative" }
const _hoisted_4 = { class: "chats-container flex-1 overflow-y-auto" }
const _hoisted_5 = { class: "chat-info flex-1 ml-3 overflow-hidden" }
const _hoisted_6 = { class: "flex justify-between items-center mt-1" }
const _hoisted_7 = {
  key: 0,
  class: "rounded-full size-6 bg-[#2a3947] animate-pulse skeleton-shine"
}

import { Search } from 'lucide-vue-next';


export default /*@__PURE__*/_defineComponent({
  __name: 'TelegramChatsSkeleton',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(Search), { class: "text-[#8a9aa9] size-4 mr-2 absolute left-3" }),
        _cache[0] || (_cache[0] = _createElementVNode("input", {
          class: "ps-10 search-bar bg-[#232e3c] rounded-md text-sm py-2 px-4 placeholder:text-[#8a9aa9] w-full focus:outline-none",
          placeholder: "Pesquisar"
        }, null, -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (i) => {
        return _createElementVNode("div", {
          key: i,
          class: "chat-item flex items-center p-3 border-b border-[#232e3c]"
        }, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "avatar-container relative" }, [
            _createElementVNode("div", { class: "avatar rounded-full size-12 bg-[#2a3947] animate-pulse skeleton-shine" })
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex justify-between items-center" }, [
              _createElementVNode("div", { class: "h-4 w-24 bg-[#2a3947] rounded animate-pulse skeleton-shine" }),
              _createElementVNode("div", { class: "h-3 w-16 bg-[#2a3947] rounded animate-pulse skeleton-shine" })
            ], -1)),
            _createElementVNode("div", _hoisted_6, [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "h-3 w-32 bg-[#2a3947] rounded animate-pulse skeleton-shine mt-2" }, null, -1)),
              (i % 3 === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      }), 64))
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "bottom-nav bg-[#17212b] border-t border-[#232e3c] p-3 flex justify-between items-center" }, [
      _createElementVNode("div", { class: "flex w-full justify-around" })
    ], -1))
  ]))
}
}

})